<template>
  <v-container fluid class="primary--text pt-0" ref="resultados-pagina" id="resultados-pagina">
    <v-row no-gutters>
      <v-col md="3" cols="12" class="hidden-sm-and-down">
        <v-row>
          <v-col cols="12" class="font-weight-bold">
            {{ $t("escenario") | capitalize }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <escenario-componente v-if="proyecto" :escenario="proyecto.escenario"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="9" cols="12">
        <v-row class="text-center" v-if="proyecto">
          <v-col cols="6" v-for="(solCons,i) in proyecto.solucionesConstructivas" :key="i">
                            <span class="body-1 font-weight-bold" style="text-transform: uppercase;">
                                {{ titulo(solCons) }}
                            </span>
            <div>
              <btn-descripcion :id="solCons.id" :id_proyecto="proyecto.id"
                               :disabled="cargandoResultados"></btn-descripcion>
              <btn-pdf :id="solCons.id" :id-proyecto="propId" :disabled="cargandoResultados"/>
            </div>
            <v-img height="120px" max-height="120px" contain :src="imgSolCons(solCons)"/>
          </v-col>
        </v-row>
        <v-row style="height: 0 !important;">
          <v-col cols="12" class="text-center pa-0">
            <v-chip class="primary--text" v-if="area">
              <v-avatar color="teal">
                <v-img :src="iconoResultado(area)"
                       min-height="30px" min-width="30px">
                </v-img>
              </v-avatar>
              <v-divider class="pa-2" style="border-right-color:#40108e;border-right-width: 1.7px"
                         inset vertical>
              </v-divider>
              <span class="pl-2">{{ area.nombre }}</span>
            </v-chip>
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col cols="6" class="pa-0">
            <puntuacion-solucion-constructiva v-if="resultados && area" size="110" color="teal accent-3"
                                              :puntuacion="isNaN(puntuaciones[0]) ? 0 : puntuaciones[0]"/>
          </v-col>
          <v-col cols="6" class="pa-0">
            <puntuacion-solucion-constructiva v-if="resultados && area" size="110" color="primary"
                                              :puntuacion="isNaN(puntuaciones[1]) ? 0 : puntuaciones[1]"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-divider class="primary my-2"/>
      </v-col>
    </v-row>
    <v-row v-if="grupo != null">
      <v-col cols="8" class="text-left">
        <span class="font-weight-bold subtitle-1 text-uppercase">{{ grupo.nombre }}</span>
      </v-col>
      <v-col cols="4" class="text-right">
        <v-btn @click="grupo = null" color="secondary">
          <v-icon color="white">mdi-chevron-left</v-icon>
          atrás
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="impactoAmbientales != null">
      <v-col cols="8" class="text-left">
                <span class="font-weight-bold subtitle-1 text-uppercase">
                    {{ impactoAmbientales.nombre }}
                </span><br>
        <span class="subtitle-2 ">
                    {{ impactoAmbientales.unidades_no_interpolado }}
                </span>
      </v-col>
      <v-col cols="4" class="text-right">
        <v-btn
            @click="impactoAmbientales = null" color="secondary">
          <v-icon color="white">mdi-chevron-left</v-icon>
          atrás
        </v-btn>
      </v-col>
    </v-row>
    <v-row
        :class="['grafico', {'economicos':(tipoArea == 'economicos')}, {'ambientales':(tipoArea == 'ambientales')}, {'prestacionales':(tipoArea != null && tipoArea.includes('prestacion'))}]">
      <v-col :cols="12">
        <grafico-eco-amb v-if="proyecto && impactoAmbientales == null && area && (area.clase.toLowerCase() == 'economicos'
                || area.clase.toLowerCase() == 'ambientales'  || area.clase.toLowerCase().trim().includes('prestacion'))"
                         :tipo-resultado="tipoResultado"
                         :tipo-area="tipoArea"
                         :soluciones-constructivas="proyecto.solucionesConstructivas"
                         :resultados="resultadosInter"
                         :label-clickeable="area && (area.clase.toLowerCase() === 'ambientales' || (area.clase.toLowerCase().trim().includes('prestacion') && grupo == null))"
                         :es-grupo-prestacional="grupo != null"
                         @label:click="clickEnLabel"/>
        <grafico-etapas-ambientales v-if="proyecto && impactoAmbientales != null"
                                    :tipo-resultado="tipoResultado"
                                    :soluciones-constructivas="proyecto.solucionesConstructivas"
                                    :resultados="resultadosInter"
                                    :id="proyecto.id"
                                    :impacto-ambientales="impactoAmbientales"/>
      </v-col>
    </v-row>
    <v-row v-if="tipoArea != 'economicos' && impactoAmbientales == null">
      <v-col cols="12" class="text-left" style="padding: 0 0 0 10px;">
                <span class="font-weight-bolb">
                    Un mayor valor equivale a una mejor solución
                </span><br>
      </v-col>
    </v-row>
    <div v-show="false" v-for="(grupoIndicador, index) in resultadosGrupo" :key="index">
      <v-row no-gutters class="teal--text accent-3">
        <v-col cols="6" class="font-weight-bold font-italic text-capitalize">
          {{ grupoIndicador.grupo.codigo }}:&nbsp;
          {{ grupoIndicador.grupo.nombre }}
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col v-for="(res, index) in grupoIndicador.completo.resultadosSolCons" :key="index"
                   cols="6" class="text-center">
              {{ res[tipoResultado] }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <resultado-indicador-componente
          v-for="(resultadoIndicador, index) in grupoIndicador.resultados" :key="index"
          :resultado-indicador="resultadoIndicador"
          :tipo-resultado="tipoResultado"/>
    </div>
    <resultado-indicador-componente v-show="false" :resultado-indicador="resultadoIndicador"
                                    v-for="(resultadoIndicador, index) in resultadosVal" :key="index"
                                    :tipo-resultado="tipoResultado"/>
  </v-container>
</template>

<script>
import EscenarioComponente from "./Componentes/Escenarios/EscenarioComponente";
import PuntuacionSolucionConstructiva from "../../components/PuntuacionSolucionConstructiva";
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import ImagenesServicio from "../../comunes/servicios/ImagenesServicio";
import ResultadoIndicadorComponente from "./Componentes/ResultadoIndicadorComponente";
import GraficoEcoAmb from "./Componentes/Graficos/GraficoEcoAmb";
import DescripcionesServicio from "../../comunes/servicios/DescripcionesServicio";
import BtnPdf from "../proyecto-detalles/Componentes/BtnPdf";
import BtnDescripcion from "../proyecto-detalles/Componentes/BtnDescripcion";
import GraficoEtapasAmbientales from "./Componentes/Graficos/GraficoEtapasAmbientales";

export default {
  name: 'ProyectoResultadosPagina',
  props: [
    'propTipoArea',
    'propTipo',
    'propId'
  ],
  components: {
    GraficoEtapasAmbientales,
    ResultadoIndicadorComponente,
    EscenarioComponente,
    PuntuacionSolucionConstructiva,
    GraficoEcoAmb,
    BtnPdf,
    BtnDescripcion
  },
  data: () => ({
    proyecto: null,
    resultados: [],
    cargandoResultados: false,
    tipoArea: null,
    grupo: null,
    impactoAmbientales: null,
    tipo: null
  }),
  computed: {
    area() {
      if (this.resultados.length < 1) return null;
      let area = null;
      this.resultados.forEach((resultado) => {
        if (resultado.area.clase.toLowerCase().trim().includes(this.tipoArea))
          area = resultado.area;
      });
      return area;
    },
    tipoResultado() {
      if (this.tipo == null) return null;

      if (this.tipo.includes("dermis")) return "dermis";
      return "completo";
    },
    tipoResultadoCambio() {
      if (this.tipo == null) return null;

      if (this.tipo.includes("dermis")) return "completo";
      return "dermis";
    },
    resultadosVal() {
      if (this.area == null) return [];
      if (this.area.clase.toLowerCase().trim().includes("prestacion")) return [];
      let results = [];
      this.resultados.forEach((result) => {
        if (result.area.clase == this.area.clase && result.resultados != null) {
          result.resultados.forEach((res) => {
            let esTotal = res.indicador.codigo.includes("AI_TOTAL");
            let esInter = res.indicador.codigo.includes("INTER");
            if (!esTotal && !esInter) results.push(res);
          });
        }
      });
      return results;
    },
    resultadosInter() {
      if (this.area == null) return [];
      let resultadosAFiltrar = JSON.parse(JSON.stringify(this.resultados));
      let results = [];
      resultadosAFiltrar.forEach((result) => {
        if (result.area.clase == this.area.clase && result.resultados != null) {
          result.resultados.forEach((res) => {
            let esTotal = res.indicador.codigo.includes("AI_TOTAL_INTER");
            let esInter = res.indicador.codigo.includes("INTER");
            if (!esTotal && esInter) results.push(res);
          });
        }
        if (result.area.clase == this.area.clase && result.area.clase.toLowerCase().trim().includes('prestacion')) {
          if (this.grupo == null) {
            result.grupos.forEach((res) => {
              let grupo_a_indicador = {
                indicador: res.grupo,
                resultadosSolCons: res.completo.resultadosSolCons,
                unidades: "",
                id: res.grupo.id,
                area: result.area
              };
              results.push(grupo_a_indicador);
            });
          } else {
            let grupo_seleccionado = result.grupos.filter((grupo) => {
              return grupo.grupo.codigo == this.grupo.codigo;
            });
            grupo_seleccionado = grupo_seleccionado[0];
            grupo_seleccionado.resultados.forEach((res) => {
              results.push(res);
            });
          }
        }
      });
      //prueba para añadirlos resultados no adimensionales
      results.forEach((result, indice) => {
        if (result.indicador.area.clase == this.area.clase) {
          let codigo_buscado = result.indicador.codigo.replace('_INTER', '');
          let resultadoClase = this.resultados.filter((resultado) => {
            return resultado.area.clase == result.indicador.area.clase;
          });
          if (result.indicador.area.clase.toLowerCase().trim().includes('prestacion')) {
            results[indice]['absoluto'] = result;
          } else {
            let resultadoCompleto = resultadoClase[0].resultados.filter((resultado) => {
              return resultado.indicador.codigo == codigo_buscado;
            });
            results[indice]['absoluto'] = resultadoCompleto[0];
          }
        }
      });
      return results;
    },
    resultadosGrupo() {
      if (this.area == null) return [];
      if (!this.area.clase.toLowerCase().trim().includes("prestacion")) return [];
      let results = [];
      this.resultados.forEach((result) => {
        if (result.area.clase == this.area.clase && result.grupos != null) {
          results = result.grupos;
        }
      });
      return results;
    },
    puntuaciones() {
      if (!this.area || this.resultados.length === 0) return [];

      let puntuaciones = [];
      [0, 1].forEach((i) => {
        this.resultados.forEach((result) => {
          if (result.area.clase == this.area.clase) {
            let res = result.completo.resultadosSolCons[i][this.tipoResultado];
            puntuaciones.push(this.convertirAFlotante(res));
          }
        });
      });

      return puntuaciones;
    }
  },
  mounted: function () {
    this.tipoArea = this.propTipoArea;
    this.tipo = this.propTipo;
    this.obtenerProyecto();
    this.obtenerResultados();
    this.$vuetify.goTo('#breadcrumbs', {
      offset: -130
    })
  },
  methods: {
    convertirAFlotante(numero) {
      return parseFloat(numero.replace(",", "."));
    },
    estableceGrupo(grupo) {
      this.grupo = grupo;
    },
    estableceImpactoAmbiental(indicador) {
      indicador.unidades_no_interpolado = this.obtenerUnidadesIndicadorAmbientalInterpolado(indicador);
      this.impactoAmbientales = indicador;
    },
    obtenerUnidadesIndicadorAmbientalInterpolado(indicador) {
      let area = this.resultados.find((resultado) => {
        return indicador.area.clase == resultado.area.clase;
      });
      let indicadorNoInterpolado = area.resultados.find((resultado) => {
        let codigo = indicador.codigo.replace("_INTER", "");
        return resultado.indicador.codigo == codigo;
      });
      return indicadorNoInterpolado.indicador.unidades;
    },
    titulo(solCons) {
      return DescripcionesServicio.materialSolCons(solCons);
    },
    obtenerProyecto() {
      let proyectoId = this.propId;
      HttpHelper.get(`proyecto/${proyectoId}`)
          .then((proyecto) => {
            this.proyecto = proyecto;
          })
          .catch(() => {
          });
    },
    obtenerResultados() {
      this.cargandoResultados = true;
      let proyectoId = this.propId;
      HttpHelper.get(`proyecto/${proyectoId}/resultados`)
          .then((resultados) => {
            this.resultados = resultados;
          })
          .catch(() => {
          })
          .finally(() => {
            this.cargandoResultados = false;
          });
    },
    iconoResultado(area) {
      let icono = "prestacionales";
      if (area.clase.toLowerCase() == "ambientales")
        icono = "ambientales";
      else if (area.clase.toLowerCase() == "economicos")
        icono = "economicos";

      return require(`../../assets/iconos/${icono}.png`);
    },
    imgSolCons(solCons) {
      if (solCons.materialPersonalizado) return solCons.materialPersonalizado.imagen;
      let imgSolConsPath = ImagenesServicio.imgSolucionConstructiva(solCons);
      if (imgSolConsPath != null) return imgSolConsPath;

      return ImagenesServicio.imgTipoSolucionConstructivaS3(solCons.tipoSolucion.codigo);
    },
    cambiar() {
      this.tipo = this.tipoResultadoCambio;
    },
    clickEnLabel(indicador) {
      if (indicador.codigo.startsWith("AI_")) this.estableceImpactoAmbiental(indicador);
      else this.estableceGrupo(indicador);
    }
  }
};
</script>

<style lang="scss">
.col-0 {
  display: none !important;
}

.info-breadcrumb {
  padding: 18px 12px;
  margin: 0;
}

.br {
  min-height: 5px;
}

.titulos-grafico {
  margin-top: 30px;
}

.grafico {

  .titulo {
    height: 52px;
    min-height: 50px;
    max-height: 50px;
    line-height: 16px;
    vertical-align: middle;
    position: relative;
    padding-top: 8px;

    span, a {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 13px;
      top: 5px;
      vertical-align: middle;
    }
  }

  &.ambientales {
    margin-top: -25px;
  }

  &.economicos {
    margin-top: -25px;

    .titulo {
      height: 45px !important;
    }

  }

  &.prestacionales {
    margin-top: -25px;

    .titulos-grafico {

      .titulo {
        span {
          top: auto !important;

        }

        .v-chip__content {
          font-size: 10px !important;
        }
      }
    }
  }
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "escenario": "escenario",
    "resultados": "resultados {0}",
    "cambiar": "cambiar a {0}"
  }
}
</i18n>
<!--@formatter:on-->